import { numberWithCommas } from "../../../../constants/utils";
import atoms from "../../../atoms";
import { BulkInventoryAddProps, ErrorDataTable, HandleBulkInventoryApiReturn } from "./interface";

const { Input, Button, Table, CustomImages } = atoms;

const BulkInventoryAdd = ({
  handleDownloadSampleFormate,
  handleFileUpload,
  inventoryData,
  handleSubmit,
  isLoading,
  errorData,
  apiError
}: BulkInventoryAddProps) => {

  const columns = [
    {
      name: "Store Name",
      selector: (row: HandleBulkInventoryApiReturn) => row.store.store_location,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Product ID",
      selector: (row: HandleBulkInventoryApiReturn) => row.product_id_display,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Cover Photo",
      cell: (row: HandleBulkInventoryApiReturn) => (
        <CustomImages src={row?.images && row?.images[0]} />
      ),
      center: true,
    },
    {
      name: "Product Type",
      selector: (row: HandleBulkInventoryApiReturn) => row?.product_type?.name,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Barcode No.",
      selector: (row: HandleBulkInventoryApiReturn) => row?.barcode,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Model Number",
      selector: (row: HandleBulkInventoryApiReturn) => row.modal_number,
      sortable: true,
    },
    {
      name: "Glass Size",
      selector: (row: HandleBulkInventoryApiReturn) => row.glass_size,
      sortable: true,
    },
    {
      name: "Product SRP",
      selector: (row: HandleBulkInventoryApiReturn) => row.product_srp,
      sortable: true,
    },
    {
      name: "Unit Cost Amount",
      selector: (row: HandleBulkInventoryApiReturn) => numberWithCommas(Number(row.unit_const_amount)),
      sortable: true,
    },
    {
      name: "Remark",
      selector: (row: HandleBulkInventoryApiReturn) => row.remarks,
      sortable: true,
    },
  ];

  const errorColumns = [
    {
      name: "Store Code",
      selector: (row: ErrorDataTable) => row?.isEmptyData ? (row?.Storecode ?? "Empty Data") : row?.Storecode ? `${row?.Storecode}` : '-',
      minWidth: "10%",
      conditionalCellStyles: [{
        when: (row: ErrorDataTable) => row?.isEmptyData ? !row?.Storecode : !row["Product ID"],
        style: { color: "red" },
      },
      ],
    },
    {
      name: "Product Id",
      selector: (row: ErrorDataTable) => row?.isEmptyData ? (row["Product ID"] ?? "Empty Data") : row["Product ID"] ? `${row["Product ID"]} ${!row?.isEmptyData && !row.Barcode ? "(Wrong Product Id)" : ""}` : "-",
      conditionalCellStyles: [{
        when: (row: ErrorDataTable) => !row?.isEmptyData && !row.Barcode,
        style: { color: "red" },
      },
      ],
    },
    {
      name: "Barcode",
      selector: (row: ErrorDataTable) => row?.isEmptyData ? (row.Barcode ?? "Empty") : (row.Barcode ?? "-"),
      sortable: true,
      minWidth: "15%",
      conditionalCellStyles: [{
        when: (row: ErrorDataTable) => row?.isEmptyData ? !row.Barcode : ( row?.inconsistentUnitCost ? false : true),
        style: { color: "red" },
      },
      ],
    },
    {
      name: "Unit Cost",
      selector: (row: ErrorDataTable) => row?.isEmptyData ? (row.Unitcost ?? "Empty") : (!row.Unitcost && row.Barcode ? `Empty` : (row?.inconsistentUnitCost ? `${row.Unitcost} (inconsistent for product unit cost)` : row.Unitcost)),
      sortable: true,
      minWidth: "15%",
      conditionalCellStyles: [{
        when: (row: ErrorDataTable) => row?.isEmptyData ? !row.Unitcost : (row?.inconsistentUnitCost ? true  : !row.Unitcost && row.Barcode),
        style: { color: "red" },
      },
      ],
    },
    {
      name: "Remarks",
      selector: (row: ErrorDataTable) => row?.isEmptyData ? (row.Remark ?? "Empty") : (row.Remark ?? ""),
      sortable: true,
      minWidth: "15%",
      conditionalCellStyles: [{
        when: (row: ErrorDataTable) => row?.isEmptyData,
        style: { color: "red" },
      },
      ],
    },
  ];

  const apiErrorColumns = [
    {
      name: "Store Name",
      selector: (row: any) => row.store.store_location,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Error",
      selector: (row: any) => row.api_response,
      sortable: true,
      minWidth: "15%",
      style: { color: "red" },
    },
  ];

  return (
    <div className="row">
      <div className="px-2 d-flex justify-content-between">
        <div className='d-flex align-items-center gap-2'>
          <label className='inputs-label mb-2 fs-16 fw-600  secondary-color'>{"Upload XLSX File"}</label>
          <Input
            type="file"
            id="formFile"
            accept='.xlsx, .xls, .csv'
            multiple={true}
            onChange={handleFileUpload}
            placeholder={"formate :- .xlsx, .xls"}
            onClick={(e: any) => (e.target.value = null)}
          />
        </div>
        <Button onClick={() => handleDownloadSampleFormate()}>Download Format </Button>
      </div>

      {/* table for show the excel data */}
      {(inventoryData?.length > 0 && apiError?.length === 0) && <Table columns={columns} data={inventoryData} />}

      {/* submit button */}
      {(inventoryData?.length > 0 && apiError?.length === 0) && <div className="d-flex justify-content-center mt-3">
        <Button onClick={() => handleSubmit()} isDisabled={isLoading}>Submit</Button>
      </div>}

      {errorData && errorData?.length > 0 && <>
        <div className="mt-25 pt-2 mb-0">
          <span className="fs-20 fw-600">
            Invalid Entries Report
          </span>
        </div>
        {/* Invalid data table */}
        <Table columns={errorColumns} data={errorData} />
      </>}

      {apiError && apiError?.length > 0 && <>
        <div className="mt-25 pt-2 mb-0">
          <span className="fs-20 fw-600">
            Invalid Entries Report
          </span>
        </div>
        {/* Invalid data table */}
        <Table columns={apiErrorColumns} data={apiError} />
      </>}
    </div>
  )
};

export default BulkInventoryAdd;